export default __webpack_public_path__ + "_/_/node_modules/@pf-loan-funnel/pf-refunds/lib/assets/error-icon-ef3e50c57991ffffdc14406ef1d95580.svg";